import { Injectable } from '@angular/core';
import { ConfigService } from 'app/core/services/config.service';
import { RequestService } from 'app/core/services/request.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class FilterableGridService {

  constructor(
    private configService: ConfigService,
    private requestService: RequestService
  ) { }

  getData(url: string) : Observable<any> {
    return this.requestService.get(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/filterable-grid/filterable-grid.service.ts